import TableBackground from '../../components/Background/TableBackground';
import BackButton from '../../components/Button/IconButton/BackButton';
import Attribution, { Licenses } from './Attribution';

import './credits.css';

interface CreditsProps {
    goToMenuCb: () => void;
}

function Credits(props: CreditsProps) {
    const { goToMenuCb } = props;

    return (
        <TableBackground>
            <div className="credits">
                <BackButton onClick={goToMenuCb} />
                <div className="title">Credits</div>
                <div className="content">
                    <div className="column">
                        <div className="subtitle">Team</div>
                        <ul>
                            <li>Cindy Jiang</li>
                            <li>Eric Higgins</li>
                            <li>Sharlene Chiu</li>
                        </ul>
                        <div className="subtitle">Fonts</div>
                        <ul>
                            <Attribution
                                usage="Fonts (Mynerve, PatrickHand)"
                                name="Google Fonts"
                                author="Google"
                                link="https://fonts.google.com"
                                licenses={[Licenses.APACHE]}
                            />
                        </ul>
                        <div className="subtitle">Art</div>
                        <ul>
                            <Attribution
                                usage="Icons (arrow_back, close, keyboard_return, visibility)"
                                name="Material Symbols"
                                author="Google"
                                link="https://fonts.google.com/icons"
                                licenses={[Licenses.APACHE]}
                            />
                            <Attribution
                                usage="Leather texture"
                                name="Fabric - Old Leather - Seamless Texture With Normalmap"
                                author="Keith333"
                                link="https://opengameart.org/content/fabric-old-leather-seamless-texture-with-normalmap"
                                licenses={[Licenses.CC_BY_3]}
                            />
                            <Attribution
                                usage="Paper"
                                name="horror game note page background old paper png"
                                author="vusos"
                                link="https://opengameart.org/content/horror-game-note-page-background-old-paper-png"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Gold texture"
                                name="*Gold*"
                                author="nicisbig"
                                link="https://opengameart.org/content/gold"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="All the hot dog game images/toppings"
                                link="https://openclipart.org/"
                                licenses={[Licenses.CC0]}
                            />
                            <li>Remaining art: Cindy Jiang</li>
                        </ul>
                    </div>
                    <div className="column">
                        <div className="subtitle">Audio</div>
                        <ul>
                            <Attribution
                                usage="Background music"
                                name="sad electric guitar loop for background music"
                                author="Garuda1982"
                                link="https://freesound.org/s/706196/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Opening diary cover"
                                name="Opening a book"
                                author="mateusboga"
                                link="https://freesound.org/s/614081/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Writing in diary"
                                name="Writing_Pen_01.wav"
                                author="moai15"
                                link="https://freesound.org/s/336382/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Key pressed (hot dog game)"
                                name="Button Clicking 3 (Single)"
                                author="Sheyvan"
                                link="https://freesound.org/s/494489/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Key denied (hot dog game)"
                                name="10 Retro RPG Menu Sounds"
                                author="leohpaz"
                                link="https://opengameart.org/content/10-retro-rpg-menu-sounds"
                                licenses={[Licenses.CC_BY_4, Licenses.CC_BY_3]}
                            />
                            <Attribution
                                usage="Enter/submit (hot dog game)"
                                name="Pressing Enter"
                                author="deleted_user_4772965"
                                link="https://freesound.org/s/256435/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Score sound (laundry game, phone game)"
                                name="clothes drop 5"
                                author="ZoviPoland"
                                link="https://freesound.org/s/517729/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Pair sock successfully (laundry game)"
                                name="Score 2"
                                author="CJspellsfish"
                                link="https://freesound.org/s/676402/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Message sent (phone game)"
                                name="Text-Message or Videogame-Jump"
                                author="CmdRobot"
                                link="https://freesound.org/s/264828/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Message received (phone game)"
                                name="Send message"
                                author="ElGamer7876"
                                link="https://freesound.org/s/702932/"
                                licenses={[Licenses.CC0]}
                            />
                            <Attribution
                                usage="Winning sound"
                                name="Win Sound #1"
                                author="remaxim"
                                link="https://opengameart.org/content/10-retro-rpg-menu-sounds"
                                licenses={[
                                    Licenses.CC_BY_SA_3,
                                    Licenses.GPL_2,
                                    Licenses.GPL_3,
                                ]}
                            />
                            <Attribution
                                usage="Losing sound"
                                name="Sad Trombone.wav"
                                author="Benboncan"
                                link="https://freesound.org/s/73581/"
                                licenses={[Licenses.CC_BY_4]}
                            />
                        </ul>
                    </div>
                </div>
            </div>
        </TableBackground>
    );
}

export default Credits;
